import { useEffect, useState } from 'react';
import { fetchActiveEvent } from '../api/eventsApi';

export function useActiveEvent(position = null) {
  const [state, setState] = useState({
    event: null,
    stats: null,
    leaderboard: [],
    loading: true,
    error: '',
  });

  useEffect(() => {
    let cancelled = false;

    setState((current) => ({ ...current, loading: true, error: '' }));

    fetchActiveEvent({
      latitude: position?.latitude ?? position?.lat ?? null,
      longitude: position?.longitude ?? position?.lng ?? null,
    })
      .then((payload) => {
        if (cancelled) return;
        setState({
          event: payload?.event || null,
          stats: payload?.stats || null,
          leaderboard: Array.isArray(payload?.leaderboard) ? payload.leaderboard : [],
          loading: false,
          error: '',
        });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({
          event: null,
          stats: null,
          leaderboard: [],
          loading: false,
          error: err?.message || 'Event konnte nicht geladen werden.',
        });
      });

    return () => {
      cancelled = true;
    };
  }, [position?.latitude, position?.lat, position?.longitude, position?.lng]);

  return state;
}

export default useActiveEvent;
